import { render, staticRenderFns } from "./ObjectsCardsList.vue?vue&type=template&id=b6adde24"
import script from "./ObjectsCardsList.vue?vue&type=script&lang=ts"
export * from "./ObjectsCardsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports